<template>
  <gift-handover-gate
    page="gift-application/gift-review-applies"
    title="贈品申請"
  >
    <section>
      <review-list :query="query" mode="apply" />
    </section>
  </gift-handover-gate>
</template>

<script>
import GiftHandoverGate from '@/components/gifts/GiftHandoverGate'
import ReviewList from '@/components/gifts/ReviewList'

export default {
  name: 'Applications',
  components: { GiftHandoverGate, ReviewList },

  data() {
    const { query } = this.$route

    return {
      query: query
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === from.name) {
      this.query = to.query
    }

    next()
  }
}
</script>
